/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import cartUpdate from './cartUpdate';
import checkout from './checkout';
import complete from './complete';
import orders from './orders';
import shelf from './shelf';
import cartItemState from './cartItemState';

export const reducers = {
  cartItemState,
  cartUpdate,
  checkout,
  complete,
  orders,
  shelf,
};
